var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeople({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.45,
    height: 26.451,
    viewBox: "0 0 26.45 26.451",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-2-users-5317716",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12170",
    "data-name": "Path 12170",
    d: "M170.888,686.058h.056l.047,0a1.111,1.111,0,0,0,1.055-1.1,9.918,9.918,0,0,0-9.919-9.919h-2.2A9.918,9.918,0,0,0,150,684.957c0,.023,0,.045,0,.067a.977.977,0,0,0,.356.745,1.094,1.094,0,0,0,.744.29s1.1-.063,1.1-1.1a7.714,7.714,0,0,1,7.715-7.715h2.2a7.714,7.714,0,0,1,7.715,7.715c0,.023,0,.045,0,.067a.977.977,0,0,0,.356.745,1.093,1.093,0,0,0,.688.289Z",
    transform: "translate(-150.005 -659.608)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12171",
    "data-name": "Path 12171",
    d: "M233.817,150a8.817,8.817,0,1,0,8.817,8.817A8.821,8.821,0,0,0,233.817,150Zm0,2.2a6.612,6.612,0,1,1-6.612,6.612A6.616,6.616,0,0,1,233.817,152.2Z",
    transform: "translate(-222.796 -150)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12172",
    "data-name": "Path 12172",
    d: "M769.844,661.132h.056l.047,0a1.111,1.111,0,0,0,1.055-1.1,9.924,9.924,0,0,0-7.025-9.49,1.1,1.1,0,0,0-.642,2.109,7.718,7.718,0,0,1,5.463,7.381c0,.023,0,.045,0,.067a.978.978,0,0,0,.356.745,1.093,1.093,0,0,0,.688.289Z",
    transform: "translate(-744.553 -635.785)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12173",
    "data-name": "Path 12173",
    d: "M764.207,227.122a5.512,5.512,0,0,1-.962,10.422,1.1,1.1,0,0,0,.495,2.148,7.716,7.716,0,0,0,1.351-14.589,1.1,1.1,0,0,0-.884,2.019Z",
    transform: "translate(-744.393 -222.806)",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeople);
export default __webpack_public_path__ + "static/media/people.c9dc791b9bf54b9e745ff9b566225ea8.svg";
export { ForwardRef as ReactComponent };